module.exports = __webpack_public_path__ + "img/xzIco (1).b1c4fa73.png";